// extracted by mini-css-extract-plugin
export default {"banderole":"banderole--toUGr","banderoleContainer":"banderoleContainer--Lfik3"};